<template lang="pug">
  el-row(style="border-top: 1px solid #dcdfe6")
    div(
      v-if="!isEditing" 
      style="float: left; font-size: 1em; padding-top: 13px; padding-left: 16px") {{tagText}}
    el-input(
      v-else 
      style="width: 220px; padding-left:0px"
      v-model="tagText")
    span(v-if="isEditing")
      el-button(
        size="small"
        circle
        icon="el-icon-close"
        style="margin-left: 8px"
        type="info"
        @click="isEditing=false"
      )   
      el-button(
        size="small"
        circle
        icon="el-icon-check"
        type="primary"
        @click="updateTag"
      ) 
    div(style="float: right; padding: 1%")
      el-button(
        size="small"
        circle
        icon="el-icon-delete"
        type="danger"
        @click="deleteTag"
      )   
      el-button(
        size="small"
        circle
        icon="el-icon-edit"
        type="success"
        @click="isEditing = true"
      ) 
  
</template>

<script>
  import utilMixin from '@/components/mixins/utilMixin'

  export default {
    name: 'TagOption',

    mixins: [utilMixin],
    
    props: {
      text: {
        type: String,
        required: true,
      },
      id: {
        type: Number,
        required: true,
      },
    },

    data() {
      return {
        isEditing: false,
        tagText: '',
      }
    },

    mounted() {
      this.tagText = this.text
    },

    methods: {
      deleteTag() {
        this.$msgbox( {
            title: 'Delete Tag',
            message: 'Do you want to permanently delete <strong>' + this.text + '</strong> tag?',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            cancelButtonText: 'Cancel',
            dangerouslyUseHTMLString: true,
            confirmButtonClass: 'delete-button',
            cancelButtonClass: 'normal-button',
          })
            .then(() => {
              this.axios.delete('/api/tags/' + this.$store.state.canvasData.userId + '/tag/' + this.id)
                .then(() => {
                  this.mNotification({message:( this.text + ' tag was deleted.')})
                  this.$emit("onTagDeleted", this.id)
                })
                .catch((error) => {
                  this.mNotification({error: error, message: 'The tag was not deleted.'})
                })        
            })
            .catch(() => { })
      },

      updateTag() {
        this.$emit("onTagUpdated", this.id, this.tagText)
        this.isEditing = false
      },  
    },
  }
</script>

<style>
</style>